export interface NotificationSoundDecision {
  enabled: boolean;
  isVisible: boolean;
  reduceMotion: boolean;
}

/** Sounds are foreground-only, opt-in, and suppressed for a reduced-motion preference. */
export function shouldPlayNotificationSound(decision: NotificationSoundDecision): boolean {
  return decision.enabled && decision.isVisible && !decision.reduceMotion;
}

/** A short, unobtrusive browser-native chime; failures are intentionally silent. */
export function playNotificationSound(enabled: boolean): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  if (!shouldPlayNotificationSound({ enabled, isVisible: document.visibilityState === 'visible', reduceMotion })) return;
  try {
    const context = new AudioContext();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.frequency.value = 660;
    gain.gain.setValueAtTime(0.035, context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 0.12);
    oscillator.connect(gain).connect(context.destination);
    oscillator.start();
    oscillator.stop(context.currentTime + 0.12);
    oscillator.addEventListener('ended', () => void context.close());
  } catch {
    // Browser autoplay/audio policies must never interrupt notification delivery.
  }
}
